export default __webpack_public_path__ + "static/media/etc_example.47dee2c5.png";